import React, { useEffect, useState } from 'react';
import './LoginPage.css';
import {
  buildAadLoginUrl,
  buildLogoutUrl,
  clearColdBootSsoAttempt,
  getAuthPrincipal,
  getPrincipalEmail,
  isAuthenticatedPrincipal,
  isInstalledPwa,
  markColdBootSsoAttempt,
  principalHasAppAccess,
  shouldAttemptColdBootSso,
} from '../utils/swaAuth';

const showGoogleLogin = false;

export default function LoginPage() {
  const apiBase = process.env.REACT_APP_API_URL || '';
  const returnUrl = encodeURIComponent(typeof window !== 'undefined' ? window.location.origin + '/' : '/');
  const [autoSigningIn, setAutoSigningIn] = useState(false);
  const [wrongAccountEmail, setWrongAccountEmail] = useState(null);

  useEffect(() => {
    document.title = 'Sign in - Clark Board';
    return () => {
      document.title = 'Clark Board';
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const principal = await getAuthPrincipal();
      if (isAuthenticatedPrincipal(principal)) {
        if (principalHasAppAccess(principal)) {
          clearColdBootSsoAttempt();
          window.location.replace('/');
          return;
        }

        if (!cancelled) {
          setWrongAccountEmail(getPrincipalEmail(principal) || 'your current account');
        }
        return;
      }

      if (!shouldAttemptColdBootSso()) return;

      setAutoSigningIn(true);
      markColdBootSsoAttempt();
      if (!cancelled) {
        window.location.href = buildAadLoginUrl('/');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const kioskMode = isInstalledPwa();

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-title">Clark Board</h1>
        <p className="login-subtitle">Sign in to view your family calendar.</p>
        {wrongAccountEmail ? (
          <div className="login-access-denied">
            <p>
              You are signed in as <strong>{wrongAccountEmail}</strong>, but that account is not
              invited to Clark Board.
            </p>
            <p>Sign out and sign in again with the email your family invited.</p>
            <a href={buildLogoutUrl('/login')} className="login-btn login-btn-microsoft">
              Sign out and try another account
            </a>
          </div>
        ) : kioskMode && autoSigningIn ? (
          <p className="login-session-note">Signing you in automatically…</p>
        ) : (
          <p className="login-session-note">
            {kioskMode
              ? 'Installed app mode: sign in once with Microsoft and keep this device signed in.'
              : 'Sign in once on your wall display; the app keeps your session active while it runs.'}
          </p>
        )}

        {!wrongAccountEmail && (
        <div className="login-buttons">
          <a
            href={`${apiBase}/.auth/login/aad?post_login_redirect_uri=${returnUrl}`}
            className="login-btn login-btn-microsoft"
          >
            Sign in with Microsoft
          </a>
          {showGoogleLogin && (
            <a
              href={`${apiBase}/.auth/login/google?post_login_redirect_uri=${returnUrl}`}
              className="login-btn login-btn-google"
            >
              Sign in with Google
            </a>
          )}
        </div>
        )}
      </div>
    </div>
  );
}
